// extracted by mini-css-extract-plugin
export var base = "_4a-0";
export var updateBanner = "_4a-1";